export var RegionExtractor = {
    id: function (item) { return item.id; },
    name: function (item) { return item.name; },
    fullName: function (item) { return item.fullName || item.name; },
};
